import { render } from "./valor-negocio.vue?vue&type=template&id=390baffc"
import script from "./valor-negocio.vue?vue&type=script&lang=js"
export * from "./valor-negocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__